import PropTypes from "prop-types";
import ContentEditor from "components/helpers/form/content-editor";
import useContent from "lib/hooks/use-content";

function CaseSubmissionsForm({onChange, onSubmit, value}) {
  const allCategories = useContent("Cases", "Categories").split(", ");
  const categories = value("categories", []);
  const onCategoryChange = (category, {target: {checked, name}}) => {
    const current = checked ? [...categories, category] : categories.filter((t) => t !== category);

    onChange({target: {name, value: current}});
  };

  return (
    <form onSubmit={onSubmit}>
      <div className="row">
        <div className="col-md-6">
          <div className="input-group mb-3">
            <div className="input-group-prepend">
              <label className="input-group-text" htmlFor="record-first-name">First Name</label>
            </div>
            <input
              className="form-control"
              id="record-first-name"
              name="first_name"
              onChange={onChange}
              placeholder="First Name"
              required={true}
              type="text"
              value={value("first_name")}
            />
          </div>
        </div>
        <div className="col-md-6">
          <div className="input-group mb-3">
            <div className="input-group-prepend">
              <label className="input-group-text" htmlFor="record-last-name">Last Name</label>
            </div>
            <input
              className="form-control"
              id="record-last-name"
              name="last_name"
              onChange={onChange}
              placeholder="Last Name"
              required={true}
              type="text"
              value={value("last_name")}
            />
          </div>
        </div>
      </div>
      <div className="input-group mb-3">
        <div className="input-group-prepend">
          <label className="input-group-text" htmlFor="record-email">Email</label>
        </div>
        <input
          className="form-control"
          id="record-email"
          name="email"
          onChange={onChange}
          placeholder="Email"
          required={true}
          type="email"
          value={value("email")}
        />
      </div>
      <div className="input-group mb-3">
        <div className="input-group-prepend">
          <label className="input-group-text" htmlFor="record-title">Case Title</label>
        </div>
        <input
          className="form-control"
          id="record-title"
          name="title"
          onChange={onChange}
          placeholder="Case Title"
          required={true}
          type="text"
          value={value("title")}
        />
      </div>
      <div className="form-group">
        <ContentEditor
          id="record-content"
          label="Content"
          name="content"
          onChange={onChange}
          value={value("content")}
        />
      </div>
      <div className="input-group mb-3">
        <div className="input-group-prepend">
          <label className="input-group-text" htmlFor="record-categories">Categories</label>
        </div>
        <div className="form-control h-auto">
          {allCategories.map((category, index) => (
            <div key={category} className="custom-control custom-switch">
              <input
                checked={categories.includes(category)}
                className="custom-control-input"
                id={`record-categories-${index}`}
                name="categories"
                onChange={onCategoryChange.bind(null, category)}
                type="checkbox"
              />
              <label className="custom-control-label" htmlFor={`record-categories-${index}`}>{category}</label>
            </div>
          ))}
        </div>
      </div>
      <div className="input-group mb-3">
        <div className="input-group-prepend">
          <label className="input-group-text" htmlFor="record-keywords">Keywords</label>
        </div>
        <input
          className="form-control"
          id="record-keywords"
          name="keywords"
          onChange={onChange}
          placeholder="Lungs, Spleen"
          type="text"
          value={value("keywords")}
        />
      </div>
      <div className="form-group text-center">
        <button type="submit" className="btn btn-primary px-5">Submit</button>
      </div>
    </form>
  );
}

CaseSubmissionsForm.propTypes = {
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  value: PropTypes.func.isRequired
};

export default CaseSubmissionsForm;
